import React from 'react';
import { Link } from 'react-router-dom';
import { PageHero } from '../components/PageHero';
import { ContactForm } from '../components/ContactForm';
import { ContactDetails } from '../components/ContactDetails';
import { SectionHeading } from '../components/SectionHeading';
import { counties, featuredCities } from '../data/serviceAreas';
import { site } from '../data/site';
export function Contact() {
  return <>
      <PageHero eyebrow="Contact" title="Schedule a free estimate" description="Call, e-mail or send the form below. Estimates and consultations are free." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Contact'
    }]} data-id="element-303" data-mp="y1qpsuwefb3g" />

      <section className="mx-auto grid max-w-7xl gap-10 px-6 py-12 lg:grid-cols-[1fr_1.2fr] md:py-16" data-id="element-304" data-mp="12zscrqwy3uk7">
        <ContactDetails data-id="element-305" data-mp="f9xz574sy1yw" />
        <div data-id="element-306" data-mp="f9ekbzag7tp3">
          <ContactForm data-id="element-307" data-mp="f8wmwzc1v9fl" />
          <p className="mt-4 text-sm leading-relaxed text-steel-500" data-id="element-308" data-mp="f83d1phso3t8">
            Prefer the phone? Estimates and plumbing:{' '}
            <a href={site.estimatePhone.href} className="font-semibold text-ink hover:text-safety" data-id="element-309" data-mp="15foudlbi6icv">
              {site.estimatePhone.display}
            </a>{' '}
            ({site.estimatePhone.alt}). Or e-mail{' '}
            <a href={site.emailHref} className="break-all font-semibold text-ink hover:text-safety" data-id="element-310" data-mp="1e8iogovlzmas">
              {site.email}
            </a>
            .
          </p>
        </div>
      </section>

      <section className="border-t border-steel-200 bg-white" data-id="element-311" data-mp="qhwg0whp0009">
        <div className="mx-auto max-w-7xl px-6 py-12" data-id="element-312" data-mp="qk8wf57sy2b7">
          <SectionHeading eyebrow="Coverage" title="Who we can come out to" description={`${counties.join(', ')} Counties in Michigan.`} data-id="element-313" data-mp="vgzl2gxoa688" />
          <div className="mt-5 flex flex-wrap gap-2" data-id="element-314" data-mp="26wxpu8lti63n">
            {featuredCities.map(c => <span key={c} className="rounded-sm border border-steel-200 px-3 py-1.5 text-sm text-ink-700" data-id="element-315" data-mp="2buzk7pop1ruf">
                {c}
              </span>)}
          </div>
          <Link to="/service-area" className="mt-5 inline-block text-sm font-bold uppercase tracking-wide text-safety hover:underline" data-id="element-316" data-mp="1h78x5tdbkusb">
            See every city →
          </Link>
        </div>
      </section>
    </>;
}